import { combineReducers, Reducer } from 'redux';
import { reducer as contentCollectionsReducer } from 'b2b-apps/shop/content/redux/contentCollections/reducer';
import {
  reducer as contentCollectionsEntriesReducer,
} from 'b2b-apps/shop/content/redux/contentCollectionsEntries/reducer';
import { reducer as contentEntriesReducer } from 'b2b-apps/shop/content/redux/contentEntries/reducer';
import { reducer as entriesMapReducer } from 'b2b-apps/shop/content/redux/entriesMap/reducer';
import { reducer as formsReducer } from 'b2b-apps/shop/content/redux/forms/reducer';
import { reducer as homepageReducer } from 'b2b-apps/shop/content/redux/homepage/reducer';
import { reducer as newsroomReducer } from 'b2b-apps/shop/content/redux/newsroom/reducer';
import { ContentActions, ContentState } from './types';

const reducer: Reducer<ContentState, ContentActions> = combineReducers({
  contentCollections: contentCollectionsReducer,
  contentCollectionsEntries: contentCollectionsEntriesReducer,
  contentEntries: contentEntriesReducer,
  entriesMap: entriesMapReducer,
  forms: formsReducer,
  newsroom: newsroomReducer,
  homepage: homepageReducer,
});

export { reducer };
